module.exports = __webpack_public_path__ + "img/08_WebFlow_11-2.9c799df9.svg";